<script>
import Vue                                  from 'vue';
import { HorizontalBar }                    from 'vue-chartjs';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';

export default {
    extends: HorizontalBar,
    props: {
        chart: {
            type: Object,
            default: null
        },
        settings: {} 
    },
    data() {
        return {
            data: {},
            chartType: '',
            chartData: { },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { position: 'top' },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        scaleLabel:{
                            display: false
                        },
                        stacked: true
                    }],
                    yAxes: [
                        { stacked: true }
                    ]
                }
            }
        }
    },
    created() {
        Vue.$log.info('※ HorizontalBarChart.vue created data =>', this.chart);
        if(this.chart !== null) {
            this.chartType = this.chart.chartType;
            this.data = this.chart.chartData;
        };

        if(['IC', 'MRC', 'CS'].includes(this.chartType)) {
            let labels = [];
            let datasets = [
                {
                    label: 'Not, yet',
                    backgroundColor: '#364fc7',
                    barThickness: 30,
                    maxBarThickness: 40,
                    data: []
                },
                {
                    label: 'Read',
                    backgroundColor: '#60c0dc',
                    barThickness: 30,
                    maxBarThickness: 40,
                    data: []
                },
            ];

            if (this.chartType === 'CS') {
                datasets[0].label = 'Helpful';
                datasets[1].label = 'Unhelpful';
            };

            for (let i = 0; i < this.data.length; i++) {
                let cData = this.data[i];
                labels.push(cData.CONTENT_NM);
                datasets[0].data.push(cData.READ);
                datasets[1].data.push(cData.NOT_YET);
            };

            Object.assign(this.chartData, {
                labels : labels,
                datasets: datasets,
            });

            Object.assign(this.options, {
                title: {
                    display: true,
                    position: 'bottom',
                    text: this.settings.TITLE,
                },
            });

        // Chart type CS
        } else {

        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options);
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/charts/HorizontalBarChart.vue